/**NOSAKContext.js — Nosak Group SSOT Context */
import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import client from "@/api/client";
import { setBadges } from "./NosAKBadgeStore";
const Ctx = createContext(null);
export const useNosak = () => useContext(Ctx);
export function NOSAKProvider({ children }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedPeriod, setSelectedPeriod] = useState("NOS-2026-FY");
  const [periods, setPeriods] = useState([{period_id:"NOS-2026-FY",label:"FY 2025/2026 (Baseline)"}]);
  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const [dashR, perR] = await Promise.all([
        client.get(`/nosak/dashboard?period_id=${selectedPeriod}`),
        client.get("/nosak/periods"),
      ]);
      const d = dashR.data;
      setData(d);
      if (perR.data?.periods?.length > 0) setPeriods(perR.data.periods);
      if (d?.period_id) setSelectedPeriod(d.period_id);
      // Compute live sidebar badges from SSOT data
      const g = d?.group || {};
      const projList = d?.projects?.list || [];
      setBadges({
        financeReady:  projList.filter(p => ["design","implementation"].includes(p.status)).length,
        evidenceGaps:  (g.data_confidence_avg || 0) < 65 ? Math.ceil((g.subsidiary_count||0) * 0.4) : 0,
        highRisks:     (g.data_confidence_avg || 0) < 65 ? 2 : 0,
        boardAlerts:   (g.data_confidence_avg || 0) < 50 ? 1 : 0,
      });
    } catch(e) { console.error("NOSAKContext load failed:", e); }
    finally { setLoading(false); }
  }, [selectedPeriod]);
  useEffect(() => { reload(); }, [selectedPeriod]);
  const group = data?.group || {};
  const subsidiaries = data?.subsidiaries || [];
  const projects = data?.projects || {};
  return (
    <Ctx.Provider value={{ data, loading, reload, selectedPeriod, setSelectedPeriod, periods, group, subsidiaries, projects }}>
      {children}
    </Ctx.Provider>
  );
}
